import { render, staticRenderFns } from "./Supply.vue?vue&type=template&id=12f78aba&scoped=true"
import script from "./Supply.vue?vue&type=script&lang=js"
export * from "./Supply.vue?vue&type=script&lang=js"
import style0 from "./Supply.vue?vue&type=style&index=0&id=12f78aba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f78aba",
  null
  
)

export default component.exports